<div *ngIf="modo==='normal'">
  <div class="flex items-center justify-center sm:justify-start text-center sm:text-left h-24 sm:h-36 bg-[var(--first-ecommerce-color)] text-[var(--third-ecommerce-color)] px-6 sm:px-12 text-2xl sm:text-3xl">
    Marcas Destacadas
  </div>
  <section class="w-[90%] mx-auto mt-16 flex justify-center" *ngIf="marcasD.length != 0; else notBrands">
    <div class="flex flex-wrap justify-center gap-1 bg-[var(--third-ecommerce-color)] shadow-md">
      <div *ngFor="let marca of marcasD" class="border-r border-b border-[var(--third-ecommerce-color)] w-40 h-40 sm:w-64 sm:h-64 md:w-[400px] md:h-[400px]">
        <div class="flex items-center justify-center h-full" (click)="irAmarcas(marca)" onclick="window.scrollTo(0,0)">
          <img class="object-contain cursor-pointer max-w-full max-h-full" [src]="marca.imagen" [alt]="marca.nombre" [width]="300" [height]="300">
        </div>
      </div>
    </div>
  </section>
  <ng-template #notBrands>
    <section class="flex justify-center">
      <div class="text-xl sm:text-2xl m-12 sm:m-20">
        No se encontraron marcas habilitadas.
      </div>
    </section>
  </ng-template>
  <mmax-helpfootbar></mmax-helpfootbar>

  <foo-mariano-max></foo-mariano-max>
</div>
<div *ngIf="modo==='pc-land'">
  <div class="flex flex-wrap justify-center gap-5">
    <div *ngFor="let marca of marcasD" class="flex items-center justify-center bg-[var(--first-ecommerce-color)] shadow-md rounded-lg w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 cursor-pointer outline-none transition-base duration-base hover:scale-105 hover:shadow-lg" (click)="irAmarcas(marca)" onclick="window.scrollTo(0,0)">
      <img class="object-contain max-w-[80%] max-h-[80%]" [src]="marca.imagen" [alt]="marca.nombre" [width]="250" [height]="250">
    </div>
  </div>
</div>
